// @flow

import type {User} from 'docs/data';
import type {UserRequestModel} from 'docs/types';

export const transformUser = (user: UserRequestModel): User => ({
  email: user.email,
  token: user.token,
});
